import React from "react";

// Classnames
import clsx from "clsx";

// Type
import { Column } from "pages/MoleculeProduct/components/TableSolubilities/TableSolubilities";

// Interface
interface ITableHeader {
  data?: Column;
}

const TableHeader: React.FC<ITableHeader> = ({ data }) => {
  const cnHeaderCell = clsx("table-solubilities__header-cell", data?.className);
  return <div className={cnHeaderCell}>{data?.title}</div>;
};

export default TableHeader;
